import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { tap, map, skip } from "rxjs/operators";
import { Observable, BehaviorSubject } from "rxjs";
import { ToastrService } from 'ngx-toastr';

import { AuthenticationService } from "src/app/core/authentication/authentication.service";

import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class UsersService {
  public permitFormValue = new BehaviorSubject(null);
  public isSaveAndExit = new BehaviorSubject({ isSaveAndExit: false, currentForm: null });

  public applicationBsSub = new BehaviorSubject(null);
  public obsApplicationBsSub = this.applicationBsSub.asObservable();

  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private TS: ToastrService
  ) { }

  checkSaveAndExit(): Observable<any> {
    return this.isSaveAndExit.asObservable().pipe(skip(1));
  }

  getPermitFormValue(): Observable<any> {
    return this.permitFormValue.asObservable();
  }

  setPermitFormValue(value) {
    this.permitFormValue.next(value);
  }

  setSelectedCity(id) {
    sessionStorage.setItem('selectedCity', id);
  }

  getSelectedCity() {
    return sessionStorage.getItem('selectedCity')
  }

  removeSelectedCity() {
    sessionStorage.removeItem('selectedCity');
  }

  setCurrentApplication(application) {
    sessionStorage.setItem("application", JSON.stringify(application));
  }

  removeApplication() {
    sessionStorage.removeItem("application");
  }

  getCurrentApplication() {
    return sessionStorage.getItem("application") ? (JSON.parse(sessionStorage.getItem("application")) || null) : null;
  }

  submittedApplication(data): Observable<any> {
    const href = environment['submitted'];
    return this.http.post<any>(href, data).pipe(map((data: any) => {
      if (data.status == 'success') {
        return data.response;
      }
    }))
  }

  resubmitedApplication(data): Observable<any> {
    const href = environment['Resubmit'];
    return this.http.post<any>(href, data).pipe(map((data: any) => {
      if (data.status == 'success') {
        return data.response;
      }
    }))
  }
  createApplication(toSend): Observable<any> {
    const href = environment['createApplication'];
    return this.http.post<any>(href, toSend).pipe(map((data: any) => {
      if (data.status == 'success') {
        return data.response;
      }
    }));
  }

  newApplication(toSend): Observable<any> {
    const href = environment['newApplication'];
    console.log(href)
    return this.http.post<any>(href, toSend).pipe(map((data: any) => {
      if (data.status == 'success') {
        return data.response;
      }
    }));
  }

  updateTenantUnit(toSend): Observable<any> {
    const href = environment['updateTenantUnit'];
    return this.http.post<any>(href, toSend).pipe(map((data: any) => {
      if (data.status == 'success') {
        return data.response;
      }
    }));
  }

  getApplications(pagination): Observable<any> {
    const href = environment['getApplications'];
    return this.http.get<any>(href, {params: pagination}).pipe(map((data: any) => {
      if (data.status == 'success') {
        return data;
      }
    }));
  }
  

  deleteTenant(payload): Observable<any>{
    const href = environment['deleteTenantUnit'];
    return this.http.post<any>(href, payload).pipe(map((data: any) => {
      console.log(data)
      if (data.status == 'success') {
        return data.response;
      }
    }));
  }

  resSubmitApp(id): Observable<any>{
    const href = environment['RessubmitApp'];
    return this.http.post<any>(href, id).pipe(map((data: any) => {
      if (data.status == 'success') {
        return data.response;
      }
    }));
  }

  uploadApplicationDocument(toSend): Observable<any> {
    const href = environment['uploadApplicationDocument'];
    return this.http.post<any>(href, toSend).pipe(map((data: any) => {
      if (data.status == 'success') {
        this.TS.success("Uploaded Successfully");
        return data.response;
      }
    }));
  }

  deleteUploads(toSend): Observable<any> {
    const href = environment['deleteDocuments'];
    return this.http.post<any>(href, toSend).pipe(map((data: any) => {
      if (data.status == 'success') {
        this.TS.success("Deleted Successfully");
        return data.response;
      }
    }));
  }

  getApplicationById(id): Observable<any> {
    const href = environment['getApplicationById'];
    return this.http.get<any>(href, {params: id}).pipe(map((data: any) => {
      if (data.status == 'success') {
        return data.response;
      }
    }));
  }

  addStaff(toSend): Observable<any> {
    const href = environment['addStaff'];
    return this.http.post<any>(href, toSend).pipe(map((data: any) => {
      if (data.status == 'success') {
        return data.response;
      }
    }));
  }


  updateApplicantProfile(toSend): Observable<any> {
    const href = environment['updateApplicantProfile'];
    return this.http.post<any>(href, toSend).pipe(map((data: any) => {
      if (data.status == 'success') {
        this.authenticationService.setUser(data.response);
        this.TS.success("Profile updated Successfully");
        return data.response;
      }
    }));
  }


  getCityList(): Observable<any> {
    const href = environment['getCityList'];
    return this.http.get<any>(href).pipe(map((data: any) => {
      if (data.status == 'success') {
        return data.response;
      }
    }));
  }

  searchAddress(searchQuery): Observable<any> {
    const href = environment['searchAddress'];
    return this.http.get<any>(href, {params: searchQuery}).pipe(map((data: any) => {
      if (data.status == 'success') {
        return data.response;
      }
    }));
  }

  getApplicationDetail(payload): Observable<any> {
    const href = environment['getUserApplicationDetail'];
    return this.http.get<any>(href, { params: payload }).pipe(map((data: any) => {
      if (data.status == 'success') {
        return data;
      }
    }))
  }


}
